<template>
    <div class="cs-course-validation"> 
        <div>
          <el-tabs class="cs-fullHeight" v-model="activeTab" type="card" @tab-click="clickTab">
          <el-tab-pane name="tabStudentList">
            <span slot='label'>同一天上两门课以上的学生(<span v-text="tableData.StudentList.length"></span>)<i v-if="tableData.StudentList.length>0" class="el-icon-warning red-icon"></i></span>
            <el-table ref="tableStudentList" :data="tableData.StudentList" stripe style="width: 100%" :header-row-class-name="'el-table-header'">
            <el-table-column type="index" min-width="5%"></el-table-column>
            <el-table-column prop="Phone" label="学生" min-width="15%">
              <template slot-scope="scope">
                  <div>
                      <el-button :class="{'isClicked':checkStudentClicked(scope.row.StudentId)}" type="text" size="medium"  v-text="formatPhone(scope.row.Phone)" @click="showStudent(scope.row.StudentId)"></el-button>
                  </div>
              </template>
            </el-table-column>
            <el-table-column prop="DayOfWeekText" label="日期" min-width="15%"> 
            </el-table-column>
            <el-table-column prop="CourseCount" label="数量" min-width="15%">
            </el-table-column>
            <el-table-column prop="CourseList" label="课程" min-width="50%">
               <template slot-scope="scope">
                    <div v-for="(item, index) in scope.row.CourseList" :key="index">
                       课程:<span v-text="item.CourseFullName"></span>&nbsp;&nbsp;
                       开始时间:<span v-text="item.StartTimeText"></span>&nbsp;&nbsp;
                       结束时间:<span v-text="item.EndTimeText"></span>
                    </div>
                </template>
            </el-table-column>
          </el-table>
          </el-tab-pane>
          <el-tab-pane name="tabTeacherList">
            <span slot='label'>同一天上两门课以上的老师(<span v-text="tableData.TeacherList.length"></span>)<i v-if="tableData.TeacherList.length>0" class="el-icon-warning red-icon"></i></span>
            <el-table ref="tableTeacherList" :data="tableData.TeacherList" stripe style="width: 100%" :header-row-class-name="'el-table-header'">
            <el-table-column type="index" min-width="5%"></el-table-column>
            <el-table-column prop="TeacherName" label="老师" min-width="15%">
              <template slot-scope="scope">
                  <div>
                      <el-button :class="{'isClicked':checkTeacherClicked(scope.row.TeacherId)}" type="text" size="medium"  v-text="scope.row.TeacherName" @click="showTeacher(scope.row.TeacherId, scope.row.TeacherName)"></el-button>
                  </div>
              </template>
            </el-table-column>
            <el-table-column prop="DayOfWeekText" label="日期" min-width="15%"> 
            </el-table-column>
            <el-table-column prop="CourseCount" label="数量" min-width="15%">
            </el-table-column>
            <el-table-column prop="CourseList" label="课程" min-width="50%">
               <template slot-scope="scope">
                    <div v-for="(item, index) in scope.row.CourseList" :key="index">
                       课程:<span v-text="item.CourseFullName"></span>&nbsp;&nbsp;
                       开始时间:<span v-text="item.StartTimeText"></span>&nbsp;&nbsp;
                       结束时间:<span v-text="item.EndTimeText"></span>
                    </div>
                </template>
            </el-table-column>
          </el-table>
          </el-tab-pane>
          </el-tabs>
         
        </div>
        <el-dialog append-to-body title="在校课程时间表" :center="true" :close-on-click-modal="false" width="70%" :visible.sync="displayStudentCourse" top="5vh">
          <studentCourseReview :data="currentStudentData" @close="closeStudentCourse" v-on:dialogFormVisibleEvent="onDialogFormVisibleEvent"></studentCourseReview>
        </el-dialog> 
          <el-dialog append-to-body title="老师课程时间表" :center="true" :close-on-click-modal="false" width="70%" :visible.sync="displayTeacherCourse" top="5vh">
      <teacherCourseReview :data="teacherCourseData" @close="closeTeacherCourse" v-on:dialogFormVisibleEvent="onTeacherDialogVisibleEvent"></teacherCourseReview>
    </el-dialog> 
    </div>
</template>

<style lang="scss" scoped>
.cs-course-validation {
  .red-icon {
    color: lightsalmon;
    margin-left: 3px;
  }
  width: 100%;
  padding: 0 40px;
  margin-bottom: 40px;
  .el-tabs {
    .el-tabs__header {
      margin: 0;
      .el-tabs__item {
        background-color: #cccccc;
        color: white;
        border: none;
        &.is-active {
          background-color: #006ab4;
        }
      }
    }
    .el-tabs__content {
      padding: 40px;
      background: white;
    }
  }
}
</style>

<script>
import studentCourseReview from "../studentCourseReview";
import teacherCourseReview from "../teacherCourseReview";
import { formatPhone } from "../../config/mUtils";

export default {
  data() {
    return {
      activeTab: "tabStudentList",
      displayStudentCourse: false,
      currentStudentData: {},
      displayTeacherCourse:false,
      teacherCourseData:{},
      tableData: {},
      plan:{},
      termId: 0,
      clickedStudentList: [],
      clickedTeacherList: [],
      
    };
  },
  components: {
    studentCourseReview,
    teacherCourseReview
  },
  props: {
    data: {}
  },
  created() {
    this.loadData();
  },
  methods: {
    formatPhone(phone){
      if (!this.USERMANAGER.isAdmin){
        return formatPhone(phone);
      }
      return phone;
    },
    clickTab(tab, event) {
        //console.log(tab, event);
        let self = this;
        setTimeout(function(){
          if (self.activeTab == "tabStudentList"){
            self.$refs.tableStudentList.doLayout();
          }else{
            self.$refs.tableTeacherList.doLayout();
          }
        }, 500)
       
    },
    closeStudentCourse() {
      this.displayStudentCourse = false;
    },
    onDialogFormVisibleEvent(visible) {
      this.displayStudentCourse = visible;
    },
    showStudent(id) {
      this.currentStudentData = {
        studentId: id,
        planId: this.plan.Id,
        termId: this.termId
      };
      this.displayStudentCourse = true;

      if (this.clickedStudentList.indexOf(id) < 0){
        this.clickedStudentList.push(id);
      }
    },
    checkStudentClicked(id) {
      if (this.clickedStudentList.indexOf(id) < 0){
        return false;
      }
      return true;
    },
    closeTeacherCourse() {
      this.displayTeacherCourse = false;
    },
    onTeacherDialogVisibleEvent(visible) {
      this.displayTeacherCourse = visible;
    },
    showTeacher(teacherId, teacherName){
      let previewData = {
        teacherId:teacherId, 
        teacherName:teacherName,
        plan: this.plan,
        termId: this.termId
      };

      this.teacherCourseData = previewData;
      this.displayTeacherCourse = true;
      if (this.clickedTeacherList.indexOf(teacherId) < 0){
        this.clickedTeacherList.push(teacherId);
      }
    },
    checkTeacherClicked(id) {
      if (this.clickedTeacherList.indexOf(id) < 0){
        return false;
      }
      return true;
    },
    loadData() {
      this.plan = this.data.plan;
      this.termId = this.data.termId;
      this.tableData = this.data.tableData;
      this.clickedStudentList = [];
      this.clickedTeacherList = [];
    }
  },
  watch: {
    data: function() {
      this.loadData();
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/speedupCourse/speedupCourseCountValidation.vue